/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

var _ = require('lodash');

module.exports = function() {
    return {
        linkHref: function(options, url) {
            if (!url || !_.isString(url)) {
                url = '';
            }

            var hash = _.get(options.hash, 'hash');

            if (hash) {
                var hashPos = url.indexOf('#');

                if (hashPos === -1) {
                    hash = '#' + hash;
                    hashPos = url.length;
                } else {
                    hashPos += 1;
                }
                url = url.substr(0, hashPos) + hash;
            }

            return url;
        },

        linkTarget: function(options, type) {
            return type === 'new' || type === 'newWindow' ? '_blank' : '_self';
        },

        decodeUri: function(options, str) {
            if (!str || !_.isString(str)) {
                return '';
            }
            return decodeURI(str);
        },

        encodeUri: function(options, str) {
            if (!str || !_.isString(str)) {
                return '';
            }
            return encodeURI(str);
        },

        concatUrl: function(options) {
            var separator = '/';
            var urlParts = options.args;
            if (urlParts && urlParts.length) {
                urlParts = _.map(urlParts, function(item, index) {
                    if (index > 0) {
                        item = _.trimStart(item, separator);
                    }
                    item = _.trimEnd(item, separator);
                    return item;
                });
                return _.join(urlParts, separator);
            }
            return '';
        },
    };
};
